import React, { useState } from "react";
import Button from "../Button";

const InputForm = ({outputPoem, handlePoemBox, isOpen}) => {
  const [keyword, setKeyword] = useState('')
  const [isValid, setIsValid] = useState(false)

  const handleSubmit = (e) => {
    e.preventDefault()
    outputPoem(keyword)
    setKeyword('')
    setIsValid(false)
  }

  const onChange = (e) => {
    setKeyword(e.target.value)
    setIsValid(false)
    if (e.target.value.length > 0) setIsValid(true)
    else setIsValid(false)
  }

  return ( 
    <form onSubmit={handleSubmit} className="inputform">
      <div className="flexbox inputform">
        <input 
          type="text"
          value={keyword} 
          className="textinput"
          onChange={onChange} 
          placeholder={"type to me"}
          accessKey=""
        />
        <input className="submit" type="submit" value="enter" 
          style={{
            color: isValid ? '' : 'hsl(var(--t-hsl)) !important',
            cursor: isValid ? '' : 'default',
          }}
        />
        <Button handleOnClick={handlePoemBox}>{isOpen ? "↑" : "↓"}</Button>
      </div>
    </form>
   );
}
 
export default InputForm;